// extracted by mini-css-extract-plugin
export default {"cards":"Dashboard_cards__Rt97I","card":"Dashboard_card__CR-j6","hide":"Dashboard_hide__ho7+b"};